var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "calculator main-view main-view--with-subnav" },
    [
      _c("div", { staticClass: "subnav" }, [
        _c("div", { staticClass: "subnav-left" }, [
          _c(
            "h2",
            {
              on: {
                click: function ($event) {
                  return _vm.test()
                },
              },
            },
            [_vm._v(" Create or Load Profile ")]
          ),
          _c(
            "div",
            {
              staticClass: "select-container",
              class: {
                "select-container--loading": _vm.profilesLoading,
                "select-container--edited": _vm.profileHasBeenChanged,
              },
            },
            [
              _c("div", { staticClass: "select" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedProfileId,
                        expression: "selectedProfileId",
                      },
                    ],
                    staticClass: "select",
                    attrs: {
                      name: "load-profile-select",
                      id: "load-profile-select",
                      placeholder: "Select...",
                      disabled: _vm.profilesLoading,
                    },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selectedProfileId = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c(
                      "option",
                      {
                        attrs: {
                          value: "-1",
                          disabled: "",
                          default: "",
                          selected: "",
                        },
                      },
                      [_vm._v("Load Existing Profile")]
                    ),
                    _vm._l(_vm.profiles, function (profile, index) {
                      return _c(
                        "option",
                        {
                          key: "profile_" + index,
                          domProps: { value: profile.id },
                        },
                        [
                          _vm._v(" " + _vm._s(profile.name) + " "),
                          _vm.profileHasBeenChanged &&
                          profile.id === _vm.selectedProfileId
                            ? _c("span", [_vm._v("[EDITED]")])
                            : _vm._e(),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]),
              _vm.profileHasBeenChanged && _vm.selectedProfileId
                ? _c("div", { staticClass: "edited-dot" })
                : _vm._e(),
              _vm.profilesLoading
                ? _c("div", { staticClass: "labs-loader" })
                : _vm._e(),
            ]
          ),
          _c(
            "button",
            {
              staticClass: "button button-secondary button-outline",
              on: {
                click: function ($event) {
                  return _vm.clearSelections()
                },
              },
            },
            [_vm._v(" Clear Selections ")]
          ),
          _c(
            "button",
            {
              staticClass: "button button-secondary button-outline",
              attrs: { disabled: _vm.calculateDisabled },
              on: {
                click: function ($event) {
                  return _vm.saveAsProfile()
                },
              },
            },
            [_vm._v(" Save As Profile ")]
          ),
          _c(
            "button",
            {
              staticClass: "button button-secondary button-outline button-icon",
              attrs: { disabled: _vm.calculateDisabled },
              on: {
                click: function ($event) {
                  return _vm.deleteProfile()
                },
              },
            },
            [_c("i", { staticClass: "material-icons" }, [_vm._v("delete")])]
          ),
          _vm.isSpecialMode
            ? _c("span", { staticClass: "special-text" }, [
                _vm._v(" Data version: "),
                _c("span", { staticClass: "special-label" }, [
                  _vm._v(" " + _vm._s(_vm.dataVersionText) + " "),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
      _c("div", { staticClass: "main-row" }, [
        _c("div", { staticClass: "main-col" }, [_c("CreateProfile")], 1),
        _c("div", { staticClass: "graph-col" }, [_c("ChartCol")], 1),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }